import React from 'react';
import { motion } from 'framer-motion';
import { Coin } from './types';

interface CoinItemProps {
  coin: Coin;
  onCollect: () => void;
}

const coinColors = {
  bronze: ['#CD7F32', '#8B4513'],
  silver: ['#C0C0C0', '#808080'],
  gold: ['#FFD700', '#DAA520'],
  gem: ['#E6E6FA', '#9370DB'],
  chest: ['#8B4513', '#D2691E'],
};

export const CoinItem: React.FC<CoinItemProps> = ({ coin, onCollect }) => {
  if (coin.collected) return null;

  const coinEmoji = 
    coin.type === 'bronze' ? '🥉' :
    coin.type === 'silver' ? '🥈' :
    coin.type === 'gold' ? '🥇' :
    coin.type === 'gem' ? '💎' : '🏆';

  const colors = coinColors[coin.type];

  const handleCollect = () => {
    onCollect();
  };

  return (
    <motion.div
      className="absolute cursor-pointer select-none text-[24px] sm:text-[32px]"
      style={{
        x: coin.x,
        y: coin.y,
        opacity: coin.collected ? 0 : 1,
        width: 'auto',
        height: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: `linear-gradient(135deg, ${colors[0]}, ${colors[1]})`,
        borderRadius: '50%',
      }}
      animate={{
        x: coin.x,
        y: coin.y,
      }}
      transition={{
        type: "spring",
        stiffness: 50,
        damping: 10
      }}
      whileHover={{ scale: 1.2 }}
      onClick={!coin.collected ? handleCollect : undefined}
    >
      {coinEmoji}
    </motion.div>
  );
};